var map = {
	"./i18n/en-us.json": [
		33655,
		"libs_shared_util_notifications_src_lib_user-terms-notice_i18n_en-us_json"
	],
	"./i18n/es-es.json": [
		44179,
		"libs_shared_util_notifications_src_lib_user-terms-notice_i18n_es-es_json"
	],
	"./i18n/pt-br.json": [
		71757,
		"libs_shared_util_notifications_src_lib_user-terms-notice_i18n_pt-br_json"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 28124;
module.exports = webpackAsyncContext;